function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListActions(props) {
  const {
    listActions
  } = props;
  const {
    isMobile
  } = useIsMobile();
  const listActionsClasses = classNames({
    [moduleStyles['sib-list__actions']]: true,
    [moduleStyles['sib-list__actions-xs']]: isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: listActionsClasses
  }, listActions === null || listActions === void 0 ? void 0 : listActions.map((item, i) => {
    return /*#__PURE__*/React.createElement(Button, _extends({}, item, {
      key: i
    }));
  }));
}
ListActions.defaultProps = {
  listActions: []
};
ListActions.propTypes = {
  listActions: PropTypes.arrayOf(PropTypes.object)
};
export default ListActions;